import React from 'react'
import classNames from 'classnames'
import { TabProps } from './Tab.d'

const Tab = ({
  heading,
  index,
  onClick,
  classes,
  isActive,
  dataTestId = 'Tab-1',
  link
}: TabProps) => {
  const tabClasses = classNames(classes, {
    'px-4 py-[10px] md:px-8 rounded-badge leading-6 cursor-pointer': true,
    'bg-gray-125 text-white !font-bold': isActive,
    'font-normal': !isActive
  })

  const tabId = heading.replace(/\s/g, '')

  return (
    <button
      aria-controls={`panel-${tabId}`}
      aria-selected={isActive}
      className={tabClasses}
      data-link={link}
      data-testid={dataTestId}
      id={`tab-${tabId}`}
      onClick={() => onClick(index)}
      role='tab'
      tabIndex={0}
    >
      {heading}
    </button>
  )
}

export default Tab
